import { createRef, ChangeEvent } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateAdministradora } from "src/Contexts/comissoes/ComissoesTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";

export const FormAdministradora = () => {
  const { valuesInputsAdministradora, setValuesInputsAdministradora } =
    useContextComissoes();
    
  const refOrigem = createRef<HTMLInputElement>();

  const handleChange =
    (prop: keyof ICreateAdministradora) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsAdministradora({
        ...valuesInputsAdministradora,
        [prop]: event.target.value,
      });
    };

  return (
    <AppTextField
      fullWidth
      inputRef={refOrigem}
      label="Administradora *"
      sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
      value={valuesInputsAdministradora?.name}
      variant="outlined"
      onChange={handleChange("name")}
    />
  );
};
